export default [
	{
		id: 1,
		title: 'Podcasts',
		cover: 'https://i.scdn.co/image/567158eb895ad26718a814345af0fc43ee785ec5',
		color: '#27856a'
	},
	{
		id: 2,
		title: 'Made For You',
		cover: 'https://t.scdn.co/images/ea364e99656e46a096ea1df50f581efe',
		color: '#1e3164'
	},
	{
		id: 3,
		title: 'Lists',
		cover: 'https://charts-images.scdn.co/assets/locale_en/regional/weekly/region_global_default.jpg',
		color: '#8c67ab'
	},
	{
		id: 4,
		title: 'New Releases',
		cover: 'https://i.scdn.co/image/ab67706f000000027ea4d505212b9de1f72c5112',
		color: '#e8105b'
	},
	{
		id: 5,
		title: 'Discover',
		cover: 'https://t.scdn.co/images/d0fb2ab104dc4846bdc56d72b0b0d785.jpeg',
		color: '#ba5d08'
	},
	{
		id: 6,
		title: 'Live Events',
		cover: 'https://t.scdn.co/images/8cfa9cb1e43a404db76eed6ad594057c',
		color: '#27856a'
	},
	{
		id: 7,
		title: 'Summer',
		cover: 'https://t.scdn.co/images/a2a24668f16c4e9680233a0d7d244a4b.jpeg',
		color: '#1e3164'
	},
	{
		id: 8,
		title: 'Popular',
		cover: 'https://t.scdn.co/media/derived/trending-274x274_7b238f7217985e79d3664f2734347b98_0_0_274_274.jpg',
		color: '#8c67ab'
	},
	{
		id: 9,
		title: 'Mood',
		cover: 'https://i.scdn.co/image/ab67706f00000002aa93fe4e8c2d24fc62556cba',
		color: '#e8105b'
	},
	{
		id: 10,
		title: 'EQUAL',
		cover: 'https://i.scdn.co/image/ab67706f0000000284a1ec26f589f0d569805a07',
		color: '#ba5d08'
	},
	{
		id: 11,
		title: 'Podcast\'ler',
		cover: 'https://t.scdn.co/images/4c8b58ab42b54296ad5379514d36edac',
		color: '#27856a'
	},
	{
		id: 12,
		title: 'Decades',
		cover: 'https://t.scdn.co/images/67a216e1e07144f889d366fed5c325bc.jpeg',
		color: '#1e3164'
	},
	{
		id: 13,
		title: 'Student',
		cover: 'https://i.scdn.co/image/ab67706f000000025f0ff9251e3cfe641160dc31',
		color: '#8c67ab'
	},
	{
		id: 14,
		title: 'League of Legends',
		cover: 'https://i.scdn.co/image/ab67706f00000002c414e7daf34690c9f983f76e',
		color: '#e8105b'
	},
	{
		id: 15,
		title: 'Chill',
		cover: 'https://t.scdn.co/images/44cf5615d3244f289fcedefa96b85db9',
		color: '#ba5d08'
	},
	{
		id: 16,
		title: 'Travel',
		cover: 'https://t.scdn.co/images/44cf5615d3244f289fcedefa96b85db9',
		color: '#27856a'
	},
	{
		id: 17,
		title: 'Fitness',
		cover: 'https://t.scdn.co/media/links/workout-274x274.jpg',
		color: '#1e3164'
	},
	{
		id: 18,
		title: 'Romance',
		cover: 'https://i.scdn.co/image/ab67706f0000000213601d4833623a4d6b328e38',
		color: '#8c67ab'
	},
	{
		id: 19,
		title: 'Sleep',
		cover: 'https://i.scdn.co/image/ab67706f00000002b70e0223f544b1faa2e95ed0',
		color: '#e8105b'
	},
	{
		id: 20,
		title: 'Classic',
		cover: 'https://i.scdn.co/image/ab67706f000000023e0130fcd5d106f1402b4707',
		color: '#ba5d08'
	}
]